import { Box, TextField, InputAdornment } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import ReviewActionButtons from './ReviewActionButtons';

interface ReviewToolbarProps {
  searchTerm: string;
  onSearchChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onDisapprove: () => void;
  onApprove: () => void;
  onDelete: () => void;
  review: string;
}

const ReviewToolbar: React.FC<ReviewToolbarProps> = ({
  searchTerm,
  onSearchChange,
  onApprove,
  onDisapprove,
  onDelete,
  review
}) => {
  return (
    <Box
      sx={{
        mb: 2,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        flexWrap: 'wrap',
        gap: 2,
      }}
    >
      <Box
        sx={{
          width: 600,
          border: '1px solid #ccc',
          borderRadius: '8px',
          background: '#fff',
        }}
      >
        <TextField
          placeholder="Search by name, email, or keyword"
          size="medium"
          value={searchTerm}
          onChange={onSearchChange}
          sx={{
            '.MuiOutlinedInput-root': { height: 40, border: 'none',width:600 },
            '& fieldset': { border: 'none' },
            '& .MuiInputBase-input': { paddingTop: '10px' },
          }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon sx={{ fontSize: 20, color: '#aaa', mt: '4px' }} />
              </InputAdornment>
            ),
          }}
        />
      </Box>

      <ReviewActionButtons onApprove={onApprove} onDisapprove={onDisapprove} onDelete={onDelete} review={review} />
    </Box>
  );
};

export default ReviewToolbar;
